module.exports = __webpack_public_path__ + "static/media/play.80865d72.svg";